
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/image-and-text",
      function () {
        return require("private-next-pages/design-system/image-and-text.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/image-and-text"])
      });
    }
  